import { useEffect, useState } from "react"

import { ContentTag, load } from "scrivito"
import { InstallationReferenceObj } from "scrivito/Objs/InstallationReference/InstallationReferenceObjClass"
import { InstallationReference } from "shared/types/InstallationReference"
import { BuildingType } from "shared/types/references/BuildingType"
import { RoomType } from "shared/types/references/RoomType"

interface UseInstallationReferenceObjTransformerArgs {
  installationReferenceObjs: InstallationReferenceObj[] | undefined
}

export function useInstallationReferenceObjTransformer({
  installationReferenceObjs
}: UseInstallationReferenceObjTransformerArgs) {
  const [installationReferences, setInstallationReferences] = useState<
    InstallationReference[] | undefined
  >(undefined)

  useEffect(() => {
    if (installationReferenceObjs) {
      Promise.all(
        installationReferenceObjs.map(async obj => {
          const [product, parent] = await Promise.all([
            load(() => obj.get("product")),
            load(() => obj.parent())
          ])

          return {
            id: obj.get("referenceID"),
            title: obj.get("title"),
            roomImage: <ContentTag content={obj} attribute="roomImageWidget" />,
            detailImage: (
              <ContentTag content={obj} attribute="detailImageWidget" />
            ),
            variantKey: product?.get("variantKey") as string,
            roomType: (obj.get("roomType") || []) as RoomType[],
            buildingType: (parent?.get("buildingType") || []) as BuildingType[],
            __obj: obj
          } as InstallationReference
        })
      ).then(result => setInstallationReferences(result))
    }
  }, [installationReferenceObjs])

  return installationReferences
}
